export default {
  namespaced: true,
  state: {
    DEFAULT_MESSAGE: 'Something happened!',
    LOGIN_SUCCESS: 'You\'re logged in successfully!',
    SIGNUP_SUCCESS: 'Account created successfully!',
    USER_UPDATE_SUCCESS: 'User updated successfully!',

    // Categories
    SAVE_TYPE_SUCCESS: 'Project type saved!',
    REMOVE_TYPE_SUCCESS: 'Project type removed!',
    REMOVE_ALL_TYPES_SUCCESS: 'Selecte project types removed!',

    // Stages
    SAVE_STAGE_SUCCESS: 'Project stage saved!',
    REMOVE_STAGE_SUCCESS: 'Project stage removed!',
    REMOVE_ALL_STAGES_SUCCESS: 'Selected project stages removed!',

    // Features
    SAVE_FEATURE_SUCCESS: 'Feature saved!',
    REMOVE_FEATURE_SUCCESS: 'Feature removed!',
    REMOVE_ALL_FEATURES_SUCCESS: 'Selected features removed!',

    // Plans
    SAVE_PLAN_SUCCESS: 'Plan saved!',
    REMOVE_PLAN_SUCCESS: 'Plan removed!',
    REMOVE_ALL_PLANS_SUCCESS: 'Selected plans removed!',

    // Contacts
    SAVE_CONTACT_SUCCESS: 'Contact saved!',
    REMOVE_CONTACT_SUCCESS: 'Contact removed!',
    REMOVE_ALL_CONTACTS_SUCCESS: 'Selected contacts removed!',

    // Projects
    SAVE_PROJECT_SUCCESS: 'Project saved!',
    REMOVE_PROJECT_SUCCESS: 'Project removed!',
    REMOVE_ALL_PROJECTS_SUCCESS: 'Selected projects removed!',

    // Issues
    LOAD_ISSUE_SUCCESS: 'Issue loaded!',
    SAVE_ISSUE_SUCCESS: 'Issue saved!',
    REMOVE_ISSUE_SUCCESS: 'Issue removed!',
    REMOVE_ALL_ISSUES_SUCCESS: 'Selected issues removed!',

    // Estimates
    SAVE_ESTIMATE_SUCCESS: 'Estimate saved!',
    REMOVE_ESTIMATE_SUCCESS: 'Estimate removed!',
    REMOVE_ALL_ESTIMATES_SUCCESS: 'Selected estimates removed!',

    // Timesheets
    SAVE_TIMESHEET_SUCCESS: 'Timesheet saved!',
    REMOVE_TIMESHEET_SUCCESS: 'Timesheet removed!',
    REMOVE_ALL_TIMESHEETS_SUCCESS: 'Selected timesheets removed!',

    // Expenses
    SAVE_EXPENSE_SUCCESS: 'Expense saved!',
    REMOVE_EXPENSE_SUCCESS: 'Expense removed!',
    REMOVE_ALL_EXPENSES_SUCCESS: 'Selected expenses removed!',

    // Roles
    SAVE_ROLE_SUCCESS: 'Role saved!',
    REMOVE_ROLE_SUCCESS: 'Role removed!',
    REMOVE_ALL_ROLES_SUCCESS: 'Selected roles removed!',

    // Users
    SAVE_USER_SUCCESS: 'User saved!',
    REMOVE_USER_SUCCESS: 'User removed!',
    REMOVE_ALL_USERS_SUCCESS: 'Selected users removed!',
  },
  getters: {},
  mutations: {},
  actions: {},
};
